module.exports = __webpack_public_path__ + "img/open.870d4689.svg";